import { render, staticRenderFns } from "./CartThanks.vue?vue&type=template&id=590228e2&"
import script from "./CartThanks.vue?vue&type=script&lang=js&"
export * from "./CartThanks.vue?vue&type=script&lang=js&"
import style0 from "./CartThanks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports